<template>
  <div class="order-detail-page">
    <div class="page-header">
      <span class="page-title">订单详情</span>
      <el-button type="primary" plain size="small" icon="el-icon-back" @click="returnFn()">返回列表</el-button>
    </div>
    <div class="descriptionsBox">
      <div v-if="userInfo && (userInfo.name || userInfo.tel)" class="info-card mt20">
        <div class="info-card-head">
          <span class="info-card-title">服务对象信息</span>
          <span v-if="orderInfo.order_status == '10'" class="status-tag">待服务</span>
          <span v-if="orderInfo.order_status == '30'" class="status-tag">服务中</span>
          <span v-if="orderInfo.order_status == '60'" class="status-tag">已完成</span>
        </div>
        <el-descriptions class="mt15" :column="3" :colon="false">
          <el-descriptions-item label="姓名">{{ userInfo.name || '-' }}</el-descriptions-item>
          <el-descriptions-item label="性别">{{ userInfo.sex || '-' }}</el-descriptions-item>
          <el-descriptions-item label="手机号">{{ userInfo.tel || '-' }}</el-descriptions-item>
          <el-descriptions-item label="身份证号">{{ orderInfo.id_card }}</el-descriptions-item>
          <el-descriptions-item label="创建时间">{{ formatDateTime(userInfo.created_at) }}</el-descriptions-item>
          <el-descriptions-item label="地址">{{ userInfo.address || '-' }}</el-descriptions-item>
          <el-descriptions-item label="健康状态">{{ orderInfo.disabled_type == '1' ? '失能' : (orderInfo.disabled_type == '2' ? '半失能' : '能力完好') }}</el-descriptions-item>
          <el-descriptions-item label="评估报告">
            <div v-if="orderInfo.disabled_img.length && orderInfo.disabled_img[0] !== ''" class="cert-imgs">
              <el-image
                v-for="(url, index) in orderInfo.disabled_img"
                :key="index"
                class="cert-img"
                :src="url"
                :preview-src-list="orderInfo.disabled_img"
                fit="cover"
              />
            </div>
            <div v-else>未评估</div>
          </el-descriptions-item>
        </el-descriptions>
      </div>

      <div v-if="orderPatientPhotos.length" class="info-card mt20">
        <div class="info-card-head">
          <span class="info-card-title">服务对象照片</span>
        </div>
        <el-descriptions class="mt15" :column="1" :colon="false">
          <el-descriptions-item label="服务对象照片">
            <div class="imgbox">
              <el-image
                v-for="(url, index) in orderPatientPhotos"
                :key="index"
                class="litimg"
                :src="url"
                :preview-src-list="orderPatientPhotos"
                fit="cover"
              />
            </div>
          </el-descriptions-item>
        </el-descriptions>
      </div>

      <div class="info-card mt20">
        <div class="info-card-head">
          <span class="info-card-title">护工信息</span>
          <el-button v-if="canAssignCaregiver" type="primary" size="small" @click="openAssignDialog">指/改派护工</el-button>
        </div>
        <el-descriptions class="mt15" :column="5" :colon="false">
          <el-descriptions-item v-if="nurseList.length > 0" label="姓名">{{ primaryNurse.name }}</el-descriptions-item>
          <el-descriptions-item v-if="nurseList.length > 0" label="手机号">{{ primaryNurse.tel }}</el-descriptions-item>
        </el-descriptions>
      </div>

      <template v-if="records.length">
        <div class="info-card mt20">
          <div class="info-card-head">
            <span class="info-card-title">服务记录</span>
            <span class="month-count-tag">本月服务次数 {{ rowData.currentMonthNum || '0' }}/{{ orderInfo.disabled_type == '1' ? '3' : '2' }}</span>
          </div>
          <el-table class="record-table" :data="records" style="width: 100%" :header-cell-style="{ background: '#fafafa', color: '#303133' }">
            <el-table-column minWidth="50" label="序号" align="center">
              <template slot-scope="scope">{{ scope.$index + 1 }}</template>
            </el-table-column>
            <el-table-column minWidth="120" label="护士信息">
              <template slot-scope="{ row: { name, tel } }">
                <div class="nurse-cell">
                  <div class="nurse-name">{{ name }}</div>
                  <div class="nurse-tel">{{ tel }}</div>
                </div>
              </template>
            </el-table-column>
            <el-table-column minWidth="140" label="开始时间">
              <template slot-scope="scope">{{ formatRecordStart(scope.row) }}</template>
            </el-table-column>
            <el-table-column minWidth="140" label="结束时间">
              <template slot-scope="scope">{{ formatRecordEnd(scope.row) }}</template>
            </el-table-column>
            <el-table-column minWidth="260" label="服务项目" class-name="service-item-col">
              <template slot-scope="scope">
                <div
                  v-if="recordServiceLineItems(scope.row).length || recordDisplayImages(scope.row).length"
                  class="service-items-block"
                >
                  <div v-if="recordServiceLineItems(scope.row).length" class="service-tags">
                    <span
                      v-for="(item, idx) in recordServiceLineItems(scope.row)"
                      :key="idx"
                      class="service-tag"
                    >
                      <span class="service-tag-name">{{ item.name || '-' }}</span>
                      <span class="service-tag-price">￥{{ item.price != null ? item.price : '-' }}</span>
                    </span>
                  </div>
                  <div v-if="recordDisplayImages(scope.row).length" class="imgbox service-item-imgs">
                    <el-image
                      v-for="(u, i) in recordDisplayImages(scope.row)"
                      :key="i"
                      class="litimg2"
                      :src="u"
                      :preview-src-list="recordDisplayImages(scope.row)"
                      fit="cover"
                    />
                  </div>
                </div>
                <span v-else class="empty-text">—</span>
              </template>
            </el-table-column>
            <el-table-column minWidth="160" label="本次服务费用">
              <template slot-scope="scope">
                <template v-if="scope.row.cdp != null && scope.row.cdp !== ''">
                  <div>￥{{ scope.row.cdp }}</div>
                  <div
                    v-if="rowDisabledCareRunningExceed(scope.row) > 0"
                    class="exceed-text"
                  >
                    {{ recordMonthLabel(scope.row) }}累计超出：￥{{ rowDisabledCareRunningExceed(scope.row) }}
                  </div>
                </template>
              </template>
            </el-table-column>
            <el-table-column minWidth="100" label="操作" align="center">
              <template slot-scope="scope">
                <el-link
                  v-if="disRoleArr.includes('5')"
                  style="margin-right: 16px"
                  type="primary"
                  @click="openEditRecordDialog(scope.row)"
                >
                  <i class="el-icon-edit"></i>
                </el-link>
                <el-link
                  v-if="scope.$index === records.length - 1 && disRoleArr.includes('6')"
                  type="danger"
                  @click="handleDeleteRecord(scope.row.id)"
                >
                  <i class="el-icon-delete"></i>
                </el-link>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </template>
    </div>

    <el-dialog
      title="服务记录"
      :visible.sync="editRecordVisible"
      width="560px"
      custom-class="service-record-edit-dialog"
      center
      destroy-on-close
      :close-on-click-modal="false"
      @closed="resetEditRecordForm"
    >
      <div class="service-record-edit-body">
        <el-form ref="editRecordForm" :model="editRecordForm" label-width="88px" label-position="left">
          <el-form-item label="开始时间">
            <el-date-picker
              v-model="editRecordForm.startTime"
              type="datetime"
              placeholder="请选择开始时间"
              value-format="timestamp"
              format="yyyy-MM-dd HH:mm"
              class="w100"
            />
          </el-form-item>
          <el-form-item label="结束时间">
            <el-date-picker
              v-model="editRecordForm.endTime"
              type="datetime"
              placeholder="请选择结束时间"
              value-format="timestamp"
              format="yyyy-MM-dd HH:mm"
              class="w100"
            />
          </el-form-item>
          <el-form-item label="服务内容" class="service-content-form-item">
            <p class="service-content-hint">最多选择 5 项</p>
            <el-checkbox-group
              v-model="editSelectedServiceIds"
              class="service-checkbox-group"
              @change="onEditSelectedServicesChange"
            >
              <el-checkbox-button
                v-for="s in editRecordCatalog"
                :key="'cat-' + String(s.id)"
                :label="String(s.id)"
              >
                <span class="svc-opt-name">{{ s.name }}</span>
                <span class="svc-opt-price">￥{{ s.price }}</span>
              </el-checkbox-button>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="服务图片" class="service-imgs-form-item">
            <div class="edit-service-imgs">
              <div v-for="(u, ui) in editRecordImgUrls" :key="ui" class="edit-img-cell">
                <el-image
                  class="edit-img-thumb"
                  :src="u"
                  fit="cover"
                  :preview-src-list="editRecordImgUrls"
                />
                <i class="el-icon-close edit-img-remove" title="移除" @click="removeEditRecordImage(ui)" />
              </div>
              <el-upload
                v-if="editRecordImgUrls.length < 9"
                class="edit-service-uploader"
                action="#"
                :show-file-list="false"
                :http-request="uploadEditRecordImage"
              >
                <div class="edit-upload-placeholder">
                  <i class="el-icon-plus" />
                </div>
              </el-upload>
            </div>
          </el-form-item>
        </el-form>
        <div class="edit-record-summary">
          <span>本次服务合计：<em>￥{{ editSelectedServicesTotal }}</em></span>
        </div>
      </div>
      <div slot="footer" class="dialog-footer edit-record-footer">
        <el-button class="btn-cancel-outline" @click="editRecordVisible = false">取 消</el-button>
        <el-button type="primary" :loading="editRecordLoading" @click="submitEditRecord">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="指/改派护工" :visible.sync="assignVisible" width="600px" center destroy-on-close :close-on-click-modal="false">
      <el-form :model="assignForm" label-width="153px">
        <el-form-item label="护工">
          <el-select
            v-model="assignForm.nurse_id"
            allow-create
            filterable
            default-first-option
            clearable
            placeholder="请选择护工"
            class="w100"
          >
            <el-option
              v-for="n in nurseCandidates"
              :key="n.id"
              :label="`${n.name}/${n.tel}`"
              :value="n.id"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="assignVisible = false">取 消</el-button>
        <el-button type="primary" :loading="assignLoading" @click="submitAssign">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  allocateOrderInfoById,
  delDeleteDisRecord,
  editNurseDailyRecord, fetchArticleServices,
  fetchNurseList,
  fetchOrdersSnDetail,
  uploadOssImgs
} from '@/api'
import pictureCompress from 'picture-compressor'
import { OrdersSnUserHospitalResult } from '@/enum/orders'
import { filterEnum } from '@/utils/filter'
import { formatDate } from 'element-ui/lib/utils/date-util'
import { getSnChildRoleIds, hasSnAssignNurse, isAdmin } from '@/utils/util'

export default {
  name: 'OrdersSnDetail',
  data() {
    return {
      orderId: '',
      editRecordVisible: false,
      editRecordLoading: false,
      editRecordForm: {
        record_id: '',
        startTime: null,
        endTime: null
      },
      editRecordTimeKeys: { startKey: 'dis_start_at', endKey: 'dis_end_at' },
      editRecordSnapshot: null,
      editRecordCatalog: [],
      editSelectedServiceIds: [],
      editRecordImgUrls: [],
      rowData: {
        orderInfo: {},
        userInfo: {},
        nurseInfo: {},
        nurseRecordsInfo: []
      },
      assignVisible: false,
      assignLoading: false,
      assignForm: {
        nurse_id: ''
      },
      nurseCandidates: [],
      isDeleteBtn: false
    }
  },
  computed: {
    disRoleArr() {
      return getSnChildRoleIds(this.$store.state.rules)
    },
    orderInfo() {
      return this.rowData.orderInfo || {}
    },
    userInfo() {
      return this.rowData.userInfo || {}
    },
    records() {
      return this.rowData.nurseRecordsInfo || []
    },
    nurseList() {
      return this.normalizeNurseInfo(this.rowData.nurseInfo)
    },
    primaryNurse() {
      return this.nurseList[0] || {}
    },
    userHospitalResultLabel() {
      const r = this.userInfo.result
      return filterEnum(r, OrdersSnUserHospitalResult).label || filterEnum(Number(r), OrdersSnUserHospitalResult).label || '-'
    },
    orderPatientPhotos() {
      const urls = this.orderInfo.img_urls
      if (!urls) return []
      if (Array.isArray(urls)) return urls.filter(Boolean)
      return String(urls)
        .split(',')
        .map(s => s.trim())
        .filter(Boolean)
    },
    canAssignCaregiver() {
      return isAdmin() || hasSnAssignNurse(this.$store.state.rules)
    },
    /** 弹窗内所选服务项目金额合计（本次） */
    editSelectedServicesTotal() {
      return (this.editSelectedServiceIds || []).reduce((sum, id) => {
        const s = this.editRecordCatalog.find(c => String(c.id) === String(id))
        const p = s ? Number(s.price) : 0
        return sum + (Number.isFinite(p) ? p : 0)
      }, 0)
    },
    /** 失能护理单月封顶：失能 150 元 / 半失能 100 元 */
    disabledCareMonthlyCap() {
      return Number(this.orderInfo.disabled_type) === 1 ? 150 : 100
    },
    /**
     * 自然月内按开始时间顺序累加 cdp，每条记录对应「截至本条后的累计超出」。
     * 未超出封顶为 0；超出后逐条递增。用 Map(row 引用) 避免无 id 时无法命中。
     */
    disabledCareRunningExceedMap() {
      const cap = this.disabledCareMonthlyCap
      const byMonth = {}
      for (const row of this.records || []) {
        const mk = this.recordMonthKey(row)
        if (!mk) continue
        if (!byMonth[mk]) byMonth[mk] = []
        byMonth[mk].push(row)
      }
      const map = new Map()
      Object.keys(byMonth).forEach(mk => {
        const rows = byMonth[mk].slice().sort((a, b) => {
          const ta = this.recordRowStartMs(a)
          const tb = this.recordRowStartMs(b)
          const va = ta != null ? ta : 0
          const vb = tb != null ? tb : 0
          if (va !== vb) return va - vb
          const ida = a.id != null ? a.id : ''
          const idb = b.id != null ? b.id : ''
          return String(ida).localeCompare(String(idb), 'en')
        })
        let running = 0
        rows.forEach(r => {
          const cdp = Number(r.cdp)
          if (Number.isFinite(cdp)) running += cdp
          const exceed = Math.max(0, running - cap)
          map.set(r, exceed)
        })
      })
      return map
    }
  },
  mounted() {
    this.orderId = this.$route.query.id || ''
    this.getDetail()
  },
  methods: {
    formatDate,
    returnFn() {
      this.$router.push('/orders_sn')
    },
    formatDateTime(v) {
      if (v == null || v === '' || v === 0) return '-'
      const n = Number(v)
      const ms = n < 1e12 ? n * 1000 : n
      return formatDate(ms, 'yyyy-MM-dd HH:mm:ss')
    },
    formatDateDay(v) {
      if (v == null || v === '' || v === 0) return '-'
      const n = Number(v)
      return formatDate(n * (n < 1e12 ? 1000 : 1), 'yyyy-MM-dd')
    },
    tsToMs(ts) {
      if (ts == null || ts === '') return null
      const n = Number(ts)
      return n < 1e12 ? n * 1000 : n
    },
    /** 服务记录归属自然月 yyyy-MM，与列表汇总一致：优先 dis_start_at，否则 service_at */
    recordMonthKey(row) {
      if (!row) return ''
      const raw = row.dis_start_at != null && row.dis_start_at !== '' ? row.dis_start_at : row.service_at != null && row.service_at !== '' ? row.service_at : null
      if (raw === null || raw === '') return ''
      const ms = this.tsToMs(raw)
      if (ms == null) return ''
      return formatDate(ms, 'yyyy-MM')
    },
    /** 展示用：如「2026-04 月」 */
    recordMonthLabel(row) {
      const k = this.recordMonthKey(row)
      return k ? `${k} 月` : '当月'
    },
    /** 用于排序：开始时间毫秒，优先 dis_start_at，否则 service_at */
    recordRowStartMs(row) {
      if (!row) return null
      const raw = row.dis_start_at != null && row.dis_start_at !== '' ? row.dis_start_at : row.service_at != null && row.service_at !== '' ? row.service_at : null
      return this.tsToMs(raw)
    },
    /** 截至本条服务后，当月累计超出封顶的金额；未超出为 0（不展示） */
    rowDisabledCareRunningExceed(row) {
      const m = this.disabledCareRunningExceedMap
      if (!m || typeof m.get !== 'function') return 0
      const v = m.get(row)
      return v != null ? v : 0
    },
    formatRecordStart(row) {
      if (row.dis_start_at != null && row.dis_start_at !== '') {
        const ms = this.tsToMs(row.dis_start_at)
        return ms != null ? formatDate(ms, 'yyyy-MM-dd HH:mm') : '-'
      }
      if (row.service_at != null && row.service_at !== '') {
        const ms = this.tsToMs(row.service_at)
        return ms != null ? formatDate(ms, 'yyyy-MM-dd HH:mm') : '-'
      }
      return '-'
    },
    formatRecordEnd(row) {
      if (row.dis_end_at != null && row.dis_end_at !== '') {
        const ms = this.tsToMs(row.dis_end_at)
        return ms != null ? formatDate(ms, 'yyyy-MM-dd HH:mm') : '-'
      }
      if (row.end_at != null && row.end_at !== '') {
        const ms = this.tsToMs(row.end_at)
        return ms != null ? formatDate(ms, 'yyyy-MM-dd HH:mm') : '-'
      }
      return '-'
    },
    normalizeNurseInfo(raw) {
      if (raw == null) return []
      if (Array.isArray(raw)) return raw.filter(Boolean)
      if (typeof raw === 'object') {
        const keys = Object.keys(raw).filter(k => /^\d+$/.test(String(k)))
        keys.sort((a, b) => Number(a) - Number(b))
        return keys.map(k => raw[k]).filter(item => item && typeof item === 'object')
      }
      return []
    },
    /** 将详情里可能是字符串的 JSON 数组解析为数组 */
    parseJsonArrayField(val) {
      if (val == null) return null
      if (Array.isArray(val)) return val
      if (typeof val === 'string') {
        const t = val.trim()
        if (!t) return null
        try {
          const p = JSON.parse(t)
          return Array.isArray(p) ? p : null
        } catch (e) {
          return null
        }
      }
      return null
    },
    pickServiceItemId(it) {
      if (!it || typeof it !== 'object') return ''
      const v =
        it.id != null && it.id !== ''
          ? it.id
          : it.item_id != null && it.item_id !== ''
            ? it.item_id
            : it.service_id != null && it.service_id !== ''
              ? it.service_id
              : ''
      return v === '' || v === undefined ? '' : String(v)
    },
    serviceRecordItems(row) {
      if (!row) return []
      const raw = this.parseJsonArrayField(row.service_json) || this.parseJsonArrayField(row.services_json)
      if (!raw || !raw.length) {
        const si = row.service_item
        if (si != null && String(si).trim() !== '') {
          return String(si)
            .split(',')
            .map(x => x.trim())
            .filter(Boolean)
            .map(id => ({ id, name: '', price: '' }))
        }
        return []
      }
      return raw.filter(s => s && (s.name || s.price != null || this.pickServiceItemId(s)))
    },
    legacyServiceLines(row) {
      if (!row.services || !row.services.length) return []
      return row.services
    },
    /** 当前行展示用的服务项目列表（优先 service_json，否则旧版 services） */
    recordServiceLineItems(row) {
      const items = this.serviceRecordItems(row)
      if (items.length) return items
      return this.legacyServiceLines(row)
    },
    /** 单个服务项目下的图片 URL 列表 */
    serviceItemImageUrls(s) {
      if (!s) return []
      if (Array.isArray(s.img_urls)) return s.img_urls.filter(Boolean)
      if (s.img_urls != null && s.img_urls !== '') {
        if (typeof s.img_urls === 'string') {
          return s.img_urls
            .split(',')
            .map(x => x.trim())
            .filter(Boolean)
        }
      }
      if (Array.isArray(s.imgs_url)) return s.imgs_url.filter(Boolean)
      if (s.imgs_url != null && s.imgs_url !== '' && typeof s.imgs_url === 'string') {
        return s.imgs_url
          .split(',')
          .map(x => x.trim())
          .filter(Boolean)
      }
      if (s.img_url != null && s.img_url !== '') {
        const u = String(s.img_url).trim()
        return u ? [u] : []
      }
      if (Array.isArray(s.imgs)) return s.imgs.filter(Boolean)
      return []
    },
    /** 整条记录的服务图片：各项目图片 + 记录级 img_urls，去重后一起展示 */
    recordDisplayImages(row) {
      const urls = []
      const seen = {}
      const push = u => {
        const s = String(u || '').trim()
        if (!s || seen[s]) return
        seen[s] = true
        urls.push(s)
      }
      this.recordServiceLineItems(row).forEach(item => {
        this.serviceItemImageUrls(item).forEach(push)
      })
      if (row && row.img_urls) {
        if (Array.isArray(row.img_urls)) {
          row.img_urls.forEach(push)
        } else {
          String(row.img_urls).split(',').forEach(x => push(x.trim()))
        }
      }
      return urls
    },
    getDetail() {
      if (!this.orderId) {
        this.$message.warning('缺少订单参数')
        return
      }
      fetchOrdersSnDetail({ order_id: this.orderId }).then(res => {
        if (res.status && res.data) {
          this.rowData = {
            orderInfo: res.data.orderInfo || {},
            userInfo: res.data.userInfo || {},
            nurseInfo: res.data.nurseInfo != null ? res.data.nurseInfo : {},
            nurseRecordsInfo: res.data.nurseRecordsInfo || [],
            currentMonthNum: res.data.currentMonthNum || '',
            currentMonthPrice: res.data.currentMonthPrice || ''
          }
        } else {
          this.$message.warning(res.msg || '加载失败')
        }
      })
    },
    /** 与订单详情 ChangeOrderNurseInfo 一致：/manage/nurses/index 不传参，data 为护工数组 */
    async getNurseList() {
      const { status, data } = await fetchNurseList()
      if (status && data != null) {
        this.nurseCandidates = Array.isArray(data) ? data : data.list || []
      } else {
        this.nurseCandidates = []
      }
    },
    async openAssignDialog() {
      await this.getNurseList()
      this.assignForm = { nurse_id: '' }
      this.assignVisible = true
    },
    submitAssign() {
      if (!this.assignForm.nurse_id) {
        this.$message.warning('请选择护工')
        return
      }
      this.assignLoading = true
      allocateOrderInfoById({
        order_id: this.orderId,
        nurse_id: this.assignForm.nurse_id
      })
        .then(res => {
          if (res.status) {
            this.$message.success(res.msg || '操作成功')
            this.assignVisible = false
            this.getDetail()
          } else {
            this.$message.warning(res.msg || '操作失败')
          }
        })
        .finally(() => {
          this.assignLoading = false
        })
    },
    handleDeleteRecord(record_id) {
      this.$confirm('确定删除服务记录吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          delDeleteDisRecord({ record_id }).then(res => {
            if (res.status) {
              this.$message.success(res.msg || '删除成功!')
              this.getDetail()
            } else {
              this.$message.warning(res.msg || '删除失败')
            }
          })
        })
        .catch(() => {})
    },
    /** 失能订单编辑：服务项目来自 /api/article/items */
    normalizeNurseServiceItem(raw) {
      if (!raw || typeof raw !== 'object') return null
      const id = raw.id != null ? raw.id : raw.item_id != null ? raw.item_id : raw.service_id
      if (id === '' || id === undefined || id === null) return null
      return {
        id: String(id),
        name: raw.name != null ? raw.name : '',
        price: raw.price != null ? raw.price : ''
      }
    },
    async loadEditRecordCatalog() {
      const params = {}
      if (this.orderId) {
        const oid = Number(this.orderId)
        params.order_id = Number.isFinite(oid) ? oid : this.orderId
      }
      const dt = this.orderInfo.disabled_type
      if (dt != null && dt !== '') {
        params.disabled_type = dt
      }
      const { status, data } = await fetchArticleServices(params)
      if (status && data != null) {
        const rawList = Array.isArray(data) ? data : data.list || []
        this.editRecordCatalog = rawList
          .map(r => this.normalizeNurseServiceItem(r))
          .filter(Boolean)
      } else {
        this.editRecordCatalog = []
      }
    },
    buildSelectedIdsFromRow(row) {
      const items = this.serviceRecordItems(row).length
        ? this.serviceRecordItems(row)
        : this.legacyServiceLines(row)
      const ids = []
      items.forEach(it => {
        let sid = this.pickServiceItemId(it)
        if (!sid && it.name) {
          const m = this.editRecordCatalog.find(
            c => c.name === it.name && String(c.price) === String(it.price)
          )
          if (m) sid = String(m.id)
        }
        if (sid && this.editRecordCatalog.some(c => String(c.id) === sid) && !ids.includes(sid)) {
          ids.push(sid)
        }
      })
      return ids.slice(0, 5)
    },
    onEditSelectedServicesChange(ids) {
      if ((ids || []).length > 5) {
        this.editSelectedServiceIds = ids.slice(0, 5)
        this.$message.warning('服务内容最多 5 项')
      }
    },
    removeEditRecordImage(imgIdx) {
      if (!this.editRecordImgUrls) return
      this.editRecordImgUrls.splice(imgIdx, 1)
    },
    uploadEditRecordImage(options) {
      const item = options
      const reader = new FileReader()
      reader.readAsDataURL(item.file)
      reader.onload = () => {
        pictureCompress({
          img: reader.result,
          width: 500,
          height: 500
        })
          .then(res => {
            return uploadOssImgs({
              data: res.img,
              dir: this.orderInfo.id_card,
              dir2: 'service',
              fileName: item.file.uid
            })
          })
          .then(resp => {
            if (resp.status && resp.data && resp.data.url) {
              this.editRecordImgUrls.push(resp.data.url)
            } else {
              this.$message.warning((resp && resp.msg) || '图片上传失败')
            }
          })
          .catch(() => {})
      }
    },
    async openEditRecordDialog(row) {
      if (!row || row.id == null) {
        this.$message.warning('记录数据异常')
        return
      }
      await this.loadEditRecordCatalog()
      this.editRecordSnapshot = row
      const startKey =
        row.dis_start_at != null && row.dis_start_at !== '' ? 'dis_start_at' : 'service_at'
      const endKey = row.dis_end_at != null && row.dis_end_at !== '' ? 'dis_end_at' : 'end_at'
      this.editRecordTimeKeys = { startKey, endKey }
      const startMs = this.tsToMs(row[startKey])
      const endMs = this.tsToMs(row[endKey])
      this.editRecordForm = {
        record_id: row.id,
        startTime: startMs != null ? startMs : null,
        endTime: endMs != null ? endMs : null
      }
      this.editSelectedServiceIds = this.buildSelectedIdsFromRow(row)
      this.editRecordImgUrls = this.recordDisplayImages(row)
      this.editRecordVisible = true
    },
    resetEditRecordForm() {
      this.editRecordSnapshot = null
      this.editRecordForm = {
        record_id: '',
        startTime: null,
        endTime: null
      }
      this.editSelectedServiceIds = []
      this.editRecordImgUrls = []
      this.editRecordCatalog = []
    },
    joinServiceItemImgUrls(urls) {
      const list = (urls || []).filter(Boolean)
      return list.length ? list.join(',') : ''
    },
    submitEditRecord() {
      const { record_id, startTime, endTime } = this.editRecordForm
      if (!record_id) {
        this.$message.warning('缺少记录 ID')
        return
      }
      const ids = (this.editSelectedServiceIds || []).map(id => String(id)).filter(Boolean)
      if (!ids.length) {
        this.$message.warning('请至少选择一项服务内容')
        return
      }
      const filled = ids.map(id => this.editRecordCatalog.find(c => String(c.id) === id)).filter(Boolean)
      if (!filled.length) {
        this.$message.warning('请至少选择一项服务内容')
        return
      }
      const toUnixSec = ts => {
        if (ts == null || ts === '') return 0
        const n = Number(ts)
        return Math.floor(n / 1000)
      }
      const imgJoined = this.joinServiceItemImgUrls(this.editRecordImgUrls)
      const service_json = filled.map((s, i) => ({
        id: String(s.id),
        name: s.name || '',
        price: s.price != null && s.price !== '' ? String(s.price) : '',
        img_urls: i === 0 ? imgJoined : ''
      }))
      const disStart = toUnixSec(startTime)
      const disEnd = toUnixSec(endTime)
      if (!disStart || !disEnd) {
        this.$message.warning('请选择开始时间与结束时间')
        return
      }
      const oid = Number(this.orderId)

      const body = {
        dis_start_at: disStart,
        dis_end_at: disEnd,
        order_id: Number.isFinite(oid) ? oid : this.orderId,
        service_json,
        img_urls: imgJoined,
        id: record_id
      }
      this.editRecordLoading = true
      editNurseDailyRecord(body)
        .then(res => {
          if (res.status) {
            this.$message.success(res.msg || '保存成功')
            this.editRecordVisible = false
            this.getDetail()
          } else {
            this.$message.warning(res.msg || '保存失败')
          }
        })
        .finally(() => {
          this.editRecordLoading = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.order-detail-page {
  padding: 16px 20px 30px;
}
.page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 14px;
  border-bottom: 1px solid #ececec;
}
.page-title {
  font-size: 18px;
  font-weight: 600;
  color: #303133;
}
.descriptionsBox {
  padding: 8px 0 0;
}
.mt20 { margin-top: 20px; }
.mt15 { margin-top: 15px; }
.info-card {
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 8px;
  padding: 16px 20px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.02);
}
.info-card-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 12px;
  border-bottom: 1px solid #f2f6fc;
}
.info-card-title {
  font-size: 15px;
  font-weight: 600;
  color: #303133;
  position: relative;
  padding-left: 10px;
}
.info-card-title::before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 3px;
  height: 14px;
  background: #26a4b2;
  border-radius: 2px;
}
.status-tag {
  font-size: 13px;
  color: #26a4b2;
  font-weight: 600;
  padding: 2px 10px;
  border-radius: 12px;
  background: rgba(38, 164, 178, 0.1);
}
.month-count-tag {
  font-size: 13px;
  color: #f56c6c;
  font-weight: 600;
}
.cert-imgs { display: flex; flex-wrap: wrap; gap: 10px; }
.cert-img { width: 90px; height: 90px; border-radius: 6px; border: 1px solid #ebeef5; }
.nurse-cell { line-height: 1.6; }
.nurse-name { font-weight: 600; color: #303133; }
.nurse-tel { color: #909399; font-size: 13px; }
.service-items-text { color: #606266; }
.empty-text { color: #c0c4cc; }
.refund-fee { color: #f56c6c; font-weight: 600; }
.delay-time { color: #f56c6c; font-weight: 600; }
.exceed-text { color: #f56c6c; }
.record-table {
  margin-top: 4px;
}
.imgbox {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  .litimg {
    width: 90px;
    height: 90px;
    margin: 4px 6px 4px 0;
    border-radius: 6px;
    border: 1px solid #ebeef5;
    object-fit: cover;
    cursor: zoom-in;
  }
  .litimg2 {
    width: 48px;
    height: 48px;
    margin: 0 6px 6px 0;
    border-radius: 6px;
    border: 1px solid #ebeef5;
    object-fit: cover;
    cursor: zoom-in;
    transition: transform 0.15s ease, box-shadow 0.15s ease;
  }
  .litimg2:hover {
    box-shadow: 0 0 0 2px rgba(38, 164, 178, 0.35);
  }
}
.service-items-block {
  text-align: left;
  padding: 2px 0;
}
.service-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}
.service-tag {
  display: inline-flex;
  align-items: center;
  max-width: 100%;
  padding: 3px 8px 3px 10px;
  background: rgba(38, 164, 178, 0.08);
  border: 1px solid rgba(38, 164, 178, 0.18);
  border-radius: 12px;
  line-height: 1.4;
}
.service-tag-name {
  color: #303133;
  font-size: 12px;
  word-break: break-all;
}
.service-tag-price {
  margin-left: 6px;
  color: #26a4b2;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
}
.service-item-imgs {
  margin-top: 8px;
}
::v-deep .service-item-col .cell {
  overflow: visible !important;
  white-space: normal !important;
}
.w100 {
  width: 100%;
}
</style>

<style lang="scss">
/* el-dialog 默认挂到 body，需非 scoped 才能命中 custom-class */
.service-record-edit-dialog {
  border-radius: 12px;
  overflow: hidden;
}
.service-record-edit-dialog .el-dialog__header {
  padding: 18px 20px 12px;
  font-weight: 600;
  font-size: 18px;
}
.service-record-edit-dialog .el-dialog__body {
  padding: 8px 20px 12px;
}
.service-record-edit-body .el-form-item {
  margin-bottom: 16px;
}
.service-content-form-item .el-form-item__label,
.service-imgs-form-item .el-form-item__label {
  float: none;
  display: block;
  text-align: left;
  width: auto !important;
  line-height: 1.4;
  margin-bottom: 6px;
}
.service-content-form-item .el-form-item__content,
.service-imgs-form-item .el-form-item__content {
  margin-left: 0 !important;
  line-height: 1.4;
}
.service-content-hint {
  font-size: 12px;
  color: #909399;
  margin: 0 0 10px;
}
.service-checkbox-group {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.service-checkbox-group .el-checkbox-button {
  margin: 0;
}
.service-checkbox-group .el-checkbox-button .el-checkbox-button__inner {
  display: inline-flex;
  align-items: center;
  padding: 6px 12px;
  font-size: 13px;
  font-weight: 400;
  line-height: 1.3;
  color: #606266;
  background: #f7f8fa;
  border: 1px solid #e4e7ed !important;
  border-radius: 16px !important;
  box-shadow: none !important;
}
.service-checkbox-group .el-checkbox-button:first-child .el-checkbox-button__inner,
.service-checkbox-group .el-checkbox-button:last-child .el-checkbox-button__inner {
  border-radius: 16px !important;
}
.service-checkbox-group .el-checkbox-button.is-checked .el-checkbox-button__inner {
  background: rgba(38, 164, 178, 0.12);
  border-color: #26a4b2 !important;
  color: #1a8a96;
  box-shadow: none !important;
}
.service-checkbox-group .el-checkbox-button.is-focus .el-checkbox-button__inner {
  border-color: #26a4b2 !important;
}
.service-checkbox-group .svc-opt-name {
  color: inherit;
}
.service-checkbox-group .svc-opt-price {
  margin-left: 6px;
  font-weight: 600;
  color: #26a4b2;
}
.service-checkbox-group .el-checkbox-button.is-checked .svc-opt-price {
  color: #1a8a96;
}
.edit-service-imgs {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}
.edit-img-cell {
  position: relative;
  width: 56px;
  height: 56px;
}
.edit-img-thumb {
  width: 56px;
  height: 56px;
  border-radius: 6px;
  cursor: zoom-in;
}
.edit-img-remove {
  position: absolute;
  top: -6px;
  right: -6px;
  font-size: 14px;
  color: #909399;
  cursor: pointer;
  background: #fff;
  border-radius: 50%;
  box-shadow: 0 0 2px rgba(0, 0, 0, 0.15);
}
.edit-img-remove:hover {
  color: #f56c6c;
}
.edit-upload-placeholder {
  width: 56px;
  height: 56px;
  border: 1px dashed #dcdfe6;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #c0c4cc;
  font-size: 20px;
  cursor: pointer;
  background: #fff;
}
.edit-upload-placeholder:hover {
  border-color: #26a4b2;
  color: #26a4b2;
}
.edit-record-summary {
  text-align: right;
  font-size: 13px;
  color: #606266;
  line-height: 1.6;
  margin-top: 8px;
  padding-top: 12px;
  border-top: 1px solid #ebeef5;
}
.edit-record-summary em {
  font-style: normal;
  color: #f56c6c;
  font-weight: 600;
}
.edit-record-summary .summary-gap {
  margin-left: 12px;
}
.edit-record-footer .btn-cancel-outline {
  border-color: #26a4b2;
  color: #26a4b2;
  background: #fff;
}
.edit-record-footer .btn-cancel-outline:hover {
  background: #ecf8f9;
}
</style>
